import React from 'react';
import { deleteEmployee, getEmployee, getEmployees, updateEmployee, getBlocks } from './../../Services/Api.service';
import { string, object } from 'yup';
import { translate } from '../../../Services/translation';

export const employeesModel = {
    root: 'employees',
    item: translate('coptikk.adminportal.employee'),
    title: translate('coptikk.adminportal.employee'),
    systemId: "systemId",
    forbidShowBlockAction: true,
    requestPostData: updateEmployee,
    requestBlockData: getBlocks,
    requestGetItem: getEmployee,
    getData: getEmployees,
    deleteRequest: deleteEmployee,
    headers: [{
        headerName: "firstName",
        label: translate('coptikk.adminportal.employee.firstname'),
        typeName: "String",
        isHiddenInIndex: false,
        isHiddenInForm: false,
        isDisabled: false
    }, {
        headerName: "lastName",
        label: translate('coptikk.adminportal.employee.lastname'),
        typeName: "String",
        isHiddenInIndex: false,
        isHiddenInForm: false,
        isDisabled: false
    },{
        headerName: "phone",
        label: translate('coptikk.adminportal.employee.phone'),
        typeName: "Phone",
        isHiddenInIndex: false,
        isHiddenInForm: false,
        isDisabled: false
    }, {
        headerName: "email",
        label: translate('coptikk.adminportal.employee.email'),
        typeName: "Email",
        isHiddenInIndex: false,
        isHiddenInForm: false,
        isDisabled: false
    }, {
        headerName: "introduction",
        label: translate('coptikk.adminportal.employee.introduction'),
        typeName: "Editor",
        isHiddenInIndex: true,
        isHiddenInForm: false,
        isDisabled: false
    }, {
        headerName: "imageUrl",
        label: translate('coptikk.adminportal.employee.image'),
        typeName: "Image",
        isHiddenInIndex: true,
        isHiddenInForm: false,
        isDisabled: false
    }, {
        headerName: "role",
        label: translate('coptikk.adminportal.employee.role'),
        typeName: "String",
        isHiddenInIndex: false,
        isHiddenInForm: false,
        isDisabled: false
    }
    ],
    validation: object().shape({
        firstName: string().required(translate(`validation.required`)),
        lastName: string().required(translate(`validation.required`)),
        mail: string().email(),
        phone: string().transform((value) => value != null ? value.replace(/\s/g, "") : value).matches(/^[0-9]+$/, "Must be only digits").notRequired().min(8, 'Must be exactly 8 digits').max(8, 'Must be exactly 8 digits').nullable().transform((value) => !!value ? value : null),
    })
}